import { Option, none, isNone, some } from 'fp-ts/lib/Option';

export default interface CreateLinkCriteria {
    dashboardId: string;
    locationId: string;
}

class CreateLinkCriteriaImpl implements CreateLinkCriteria {
    constructor(readonly dashboardId: string, readonly locationId: string) {}
}

export class CreateLinkCriteriaBuilder {
    private dashboardId: Option<string> = none;

    private locationId: Option<string> = none;

    static create = (): CreateLinkCriteriaBuilder => new CreateLinkCriteriaBuilder();

    withDashboardId = (dashboardId: string): CreateLinkCriteriaBuilder => {
        this.dashboardId = some(dashboardId);
        return this;
    };

    withLocationId = (locationId: string): CreateLinkCriteriaBuilder => {
        this.locationId = some(locationId);
        return this;
    };

    build = (): CreateLinkCriteria => {
        if (isNone(this.dashboardId) || isNone(this.locationId)) {
            throw new ReferenceError('Undefined prop');
        }

        return new CreateLinkCriteriaImpl(this.dashboardId.value, this.locationId.value);
    };
}
